import PrintIcon from "@mui/icons-material/Print";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import {RowData} from "@tanstack/react-table";
import {useState} from "react";
import {useTranslation} from "react-i18next";
import {ServerTableInstance} from "../types";
import {ServerTablePrintDialog} from "./ServerTablePrintDialog";
import {serverTableControlIconSx, serverTableControlSx} from "../constants";
import {ServerTablePrintOrientation, ServerTablePrintRows} from "./types";

interface ServerTablePrintButtonProps<TData extends RowData> {
    table: ServerTableInstance<TData>
    title?: string
    selectedDate?: Date
    initialOrientation?: ServerTablePrintOrientation
    disabled?: boolean
    onBeforeOpen?: () => void
    /** Collects rows beyond the loaded page; see `ServerTableController.printRows`. */
    printRows?: ServerTablePrintRows<TData>
}

export function ServerTablePrintButton<TData extends RowData>({
    table,
    title,
    selectedDate,
    initialOrientation,
    disabled,
    onBeforeOpen,
    printRows
}: ServerTablePrintButtonProps<TData>) {
    const {t} = useTranslation();
    const [open, setOpen] = useState(false);

    const openPrintPreview = () => {
        onBeforeOpen?.();
        setOpen(true);
    };

    return (
        <>
            <Tooltip title={t('Print')}>
                <span>
                    <IconButton
                        size="small"
                        color="primary"
                        data-dashboard-control=""
                        aria-label={t('Print')}
                        disabled={disabled}
                        onClick={openPrintPreview}
                        sx={serverTableControlSx}
                    >
                        <PrintIcon sx={serverTableControlIconSx}/>
                    </IconButton>
                </span>
            </Tooltip>

            <ServerTablePrintDialog
                open={open}
                onClose={() => setOpen(false)}
                table={table}
                title={title}
                selectedDate={selectedDate}
                initialOrientation={initialOrientation}
                printRows={printRows}
            />
        </>
    );
}
